// extracted by mini-css-extract-plugin
export default {"drawer-template-additional-details":"styles_drawer-template-additional-details__dQGRs"};